module.exports = __webpack_public_path__ + "img/keyboard.364f37c3.svg";